const tallyRouter = [
  {
    path: "tally",
    name: "tally",
    component: () => import("../pages/tally/Tally.vue"),
    meta: {
      title: "PC点货",
    },
  },

  {
    path: "tally2",
    name: "tally2",
    component: () => import("../pages/tally/Tally2.vue"),
    meta: {
      title: "PC点货_NEW",
    },
  },
  {
    path: "goods-out-of-log",
    name: "GoodsOutOfStock",
    component: () => import("../pages/log/GoodsOutOfStock.vue"),
    meta: {
      title: "商品库断货日志",
    },
  },
  {
    path: "re-da-biao",
    name: "ReDaBiao",
    component: () => import("../pages/tally/ReDaBiao.vue"),
    meta: {
      title: "PC重打",
    },
  },
  //  无数据点货
  {
    path: "not_data_goods_tally",
    name: "notDataGoodsTally",
    component: () => import("../pages/nodatagoods/NoDataGoodsTally.vue"),
    meta: {
      title: "无数据点货",
    },
  },

  // 新pc点货
  {
    path: "takeStock",
    name: "takeStock",
    component: () => import("../pages/takeStock/takeStock.vue"),
    meta: {
      title: "PC点货-REMAKE",
    },
  },
  //  仓库盘盈
  {
    path: "tally/StorageSurplus",
    name: "StorageSurplus",
    component: () => import("../pages/tally/StorageSurplus.vue"),
    meta: {
      title: "仓库盘盈",
    },
  },
  // 在途库存列表
  {
    path: "Common/getErpMenu",
    name: "erpMenu",
    component: () => import("../pages/tally/stockInTransitList/index.vue"),
    meta: {
      title: "在途库存列表",
    },
  },
];

export default tallyRouter;



// WEBPACK FOOTER //
// ./src/router/tallyRouter.js